import type React from 'react';

interface SkeletonWrapperProps {
  loading: boolean;
  skeleton: React.ReactNode;
  children: React.ReactNode;
}

const SkeletonWrapper: React.FC<SkeletonWrapperProps> = ({ loading, skeleton, children }) => {
  return loading ? skeleton : children;
};

export default SkeletonWrapper;
